// PFA/DFA/AFD channel copy for /pf, transcribed from the approved mockup
// (docs/omw419/copy/PF.txt). Terms are legal's copy from Figma (2026-10-01):
// the shared platform terms, then the PF-only Will Incentive section and the
// shared Executor Fee Share section (docs/omw419/copy/terms-and-conditions.md).
import { PFA_CHANNEL_COMPANY_IDS } from '@/constants/adviser-channel-companies';
import {
  EXECUTOR_FEE_SHARE_TERMS,
  PLATFORM_TERMS,
} from '@/constants/adviser-enrolment/platform-terms';

export const PF_WILL_INCENTIVE_TERMS = {
  heading: 'Will Incentive',
  items: [
    'The Will Incentive is available to advisers in the PFA, DFA and AFD channels.',
    "The incentive applies to wills validated on the Old Mutual Will Platform between 1 January 2026 and 31 December 2026, inclusive. Only a client's first will validated on the Platform during the incentive period qualifies. An amendment, update or replacement of that client's will does not qualify for an additional payment.",
    'The maximum aggregate amount payable to an adviser under the Will Incentive during the incentive period is R60 000.',
    'Payments will be made by PF through OMIpay, subject to verification of eligibility and the applicable payment processes.',
    'Old Mutual Will reserves the right to verify all qualifying validations before payment is made.',
    'Old Mutual Will may withhold, decline or recover any incentive payment where it reasonably determines that a validation, appointment or claim does not comply with these Terms and Conditions, the applicable channel agreement, applicable law, or involves fraud, abuse or manipulation of the incentive.',
    'Queries relating to the incentive may be directed to adviser@oldmutualwill.co.za.',
    'General Old Mutual Will Platform Terms and Conditions apply.',
  ],
};

export const PF_CHANNEL = {
  key: 'pfa',
  heroSection: 'adviserPfHeader',
  companyIds: PFA_CHANNEL_COMPANY_IDS,
  intro: {
    heading: 'Why Wills matter',
    lead: '85%<sup>1</sup> of South Africans die without a will, leaving their families vulnerable when the unexpected happens. As trusted financial advisers, you have the power to change this.',
    paragraphs: [
      "Through the <strong>Old Mutual Will platform</strong>, we're making it easier than ever to help clients <strong>protect their legacy and provide for their loved ones</strong>.",
    ],
    footnote: "1. According to Master's Office 2022",
  },
  earnings: {
    heading: 'Boost your earnings with Will services',
    intro:
      'From 1 January 2026 to 31 December 2026, Old Mutual Will gives you:',
    bullets: [
      "R500 (pre-tax) for a validated will from your clients, with a maximum annual earning of R60 000 from this incentive. The incentive is triggered for a client's first will on the Old Mutual Will platform",
      'A new way to add value to client relationships',
      'A simple tool to help identify estate planning opportunities.',
      'Support from our dedicated team throughout the process',
      'Please note, this current incentive applies to PFA, DFA, and AFD adviser channels.',
    ],
    outro:
      'Simply register as an adviser on the platform to get started.<br />View <a href="#terms">Terms and conditions</a>',
  },
  incentives: {
    heading: 'Incentives',
    lead: "Earn R500 for every client's first validated Will, completed through the Old Mutual Will platform, up to a maximum of R60 000 per year.",
    body: "In addition, because Old Mutual Will is appointed as executor when a Will is completed on the platform, participating advisers can earn a 20% share of executor's fees on estates valued between R1 million and R5 million, and 25% on estates above R5 million. The applicable channel agreement sets the fee payable for the specific channel.",
  },
  resources: {
    heading: 'Resources',
    subtitle:
      'Below are a number of resources that outlines the opportunity, and supports you to get you started on the platform.',
  },
  brochures: [
    {
      icon: 'document',
      title: 'OM Will Adviser One Pager',
      description:
        'All the key facts about the Old Mutual Will proposition that you as an adviser may need.',
      buttonText: 'Download',
      download: 'PFA_Adviser_OnePager_26_V1.pdf',
    },
    {
      icon: 'document',
      title: 'OM Will and OMP Overview',
      description:
        'An overview of how OM Will informs financial planning conversations with clients and enables OMP sales.',
      buttonText: 'Download',
      download: 'PFA_Adviser_OMWill_OMP_Overview_26_V1.pdf',
    },
    {
      icon: 'document',
      title: 'OM Will and OMP - How it works',
      description:
        'A description of how the OM Will platform enables you to capture the OMP sale.',
      buttonText: 'Download',
      download: 'PFA_Adviser_OMWill_OMP_HowTo_26_V1.pdf',
    },
  ],
  terms: {
    ...PLATFORM_TERMS,
    sections: [PF_WILL_INCENTIVE_TERMS, EXECUTOR_FEE_SHARE_TERMS],
  },
};
